<template>
  <div class="animated fadeIn">
    <div v-if="iscreate">
      <createreq @created="iscreate = false"></createreq>
    </div>
    <div v-if="isedit">
      <editreq @edit="isedit = false" :itemObj="servicerequest"></editreq>
    </div>
    <div v-if="isview">
      <viewreq @view="isview = false" :itemObj="servicerequest"></viewreq>
    </div>
    <b-card
      class="card-wrap"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
      v-if="!iscreate && !isedit && !isview"
    >
      <div slot="header">
        <strong>Service Request</strong>
        <eb-button
          class="btn float-right mr-2"
          classic="mr-1 btn-success"
          text="Create"
          icon="fa fa-plus-circle mr-1"
          iconSide="left"
          @click="iscreate = true"
        ></eb-button>
      </div>
      <!-- <b-row>
        <b-col md="12" v-if="!iscreate && !isedit && !isview">
          <eb-button
            class="btn float-right mr-2"
            classic="mr-1 btn-primary"
            text="Create"
            icon="fa fa-plus-circle mr-1"
            iconSide="left"
            @click="iscreate=true"
          ></eb-button>
        </b-col>
      </b-row> -->

      <div class="mt-2" v-if="!iscreate && !isedit && !isview">
        <b-table
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          id="my-table"
          :current-page="currentPage"
          :per-page="perPage"
          :items="servicerequests"
          thead-class="header"
          class="mt-3 tableRadius"
          :fields="Columns"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <div class="inline_btnTable">
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="primary"
                @click="viewReq(data)"
              >
                <i class="fa fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="primary"
                @click="editReq(data)"
              >
                <i class="fas fa-pencil-alt edit"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="danger"
                @click="deleteReq(data)"
              >
                <i class="fa fa-trash bin"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div style="float: right" v-if="!iscreate && !isedit && !isview">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="servicerequests.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
      <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import createreq from "@/components/MasterSetup/ServiceRequest/CreateRequest.vue";
import editreq from "@/components/MasterSetup/ServiceRequest/EditRequest.vue";
import viewreq from "@/components/MasterSetup/ServiceRequest/ViewRequest.vue";

export default {
  name: "servicerequestdetails",
  components: {
    ebButton,
    loader,
    createreq,
    editreq,
    viewreq,
  },
  data() {
    return {
      perPage: 5,
      iscreate: false,
      isedit: false,
      sortBy: "createdAt",
      sortDesc: true,
      isview: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      context: "Add",
      Columns: [
        {
          key: "Category",
          sortable: true,
        },
        {
          key: "Description",
        },
        {
          key: "Scope",
        },

        {
          key: "Severity",
        },

        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    servicerequests() {
      let data = this.$store.getters["servicerequest/GetServiceRequestList"];
      console.log("hai", data);
      let ServiceRequestList = [];
      console.log("list", ServiceRequestList);
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          // for (let i = 0; i < obj.items.length; i++) {
          let arrayObj = {
            Category: obj.name,
            Description: obj.description,
            Scope: obj.scope,
            Severity: obj.severity,
            id: obj._id,
            ...obj,
          };
          ServiceRequestList.push(arrayObj);
          // }
        });
        return ServiceRequestList;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    editReq(data) {
      this.servicerequest = data.item;
      this.isedit = true;
    },
    viewReq(data) {
      console.log("100", data);
      this.servicerequest = data.item;
      this.isview = true;
    },
    async deleteReq(data) {
      this.$swal({
        title: "Delete this ServiceRequest?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("servicerequest/deleteRequest", data.item._id)
            .then((result) => {
              this.$toasted.success("Request Deleted Successfully");
              this.$store
                .dispatch(
                  "servicerequest/fetchServicerequestList"
                  // this.$store.getters["auth/getUserID"]
                )
                .catch((error) => {
                  this.$toasted.error(error.message);
                });
            });
        }
      });
      this.$store.dispatch(
        "servicerequest/fetchServicerequestList"
        // this.$store.getters["auth/getUserID"]
      );
    },
  },
  async mounted() {
    // console.log("id",this.data.item.id)
    await this.$store
      .dispatch("servicerequest/fetchServicerequestList")
      .then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        } else {
        }
      });
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
